import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo } from "react";
import { FormUI, InputUI } from "@parkschannel/ui";
import { PlannerResourceType } from "@parkschannel/contracts";
import { useTripPlanerContext } from "../TripPlannerContext";
export const Filters = (param)=>{
    let { data  } = param;
    const { onFilterChange , planner  } = useTripPlanerContext();
    const placeOptions = useMemo(()=>{
        return (data === null || data === void 0 ? void 0 : data.toFilter(data.plannerPlaces)) || [];
    }, [
        data
    ]);
    const activityOptions = useMemo(()=>{
        return (data === null || data === void 0 ? void 0 : data.toFilter(data.plannerActivities)) || [];
    }, [
        data
    ]);
    const getOptionValue = useCallback((options)=>options.map((option)=>option.value), []);
    return /*#__PURE__*/ _jsx("div", {
        className: "bg-neutral-50 p-4 w-full rounded-lg",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "gap-6 flex flex-col lg:flex-row lg:items-center ",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ _jsx(FormUI.Label, {
                            htmlFor: "where-to-go",
                            children: "Where do you want to go?"
                        }),
                        /*#__PURE__*/ _jsx(InputUI.Select, {
                            placeholder: "Select the environments",
                            options: placeOptions,
                            value: planner.filters[PlannerResourceType.PLACE].map((item)=>placeOptions.find((el)=>el.value === item)),
                            onChange: (selected)=>onFilterChange({
                                    type: PlannerResourceType.PLACE,
                                    items: getOptionValue(selected)
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ _jsx(FormUI.Label, {
                            htmlFor: "what-to-do",
                            children: "What would you like to do?"
                        }),
                        /*#__PURE__*/ _jsx(InputUI.Select, {
                            id: "what-to-do",
                            placeholder: "Select activities",
                            value: planner.filters[PlannerResourceType.ACTIVITY].map((item)=>activityOptions.find((el)=>el.value === item)),
                            options: activityOptions,
                            onChange: (selected)=>onFilterChange({
                                    type: PlannerResourceType.ACTIVITY,
                                    items: getOptionValue(selected)
                                })
                        })
                    ]
                })
            ]
        })
    });
};
